import { RolesEnum } from "@/lib/types/roles.types";
import { pageToIcon } from "./page-to-icon";

export function getAppListMenuItems(role: RolesEnum) {
	return [
		{
			key: "dashboard-home",
			title: "Dashboard",
			path: "/",
			icon: pageToIcon("dashboard-home", {
				width: "16px",
				height: "16px",
				color: "rgb(55, 65, 81)",
			}),
			isGated: false,
		},
		{
			key: "chats",
			title: "Chats",
			path: "/chats",
			icon: pageToIcon("chats", {
				width: "16px",
				height: "16px",
				color: "rgb(55, 65, 81)",
			}),
			isGated: false,
		},
		{
			key: "auftraege",
			title: "Auftragsübersicht",
			path: "/auftraege",
			icon: pageToIcon("dashboard", {
				width: "16px",
				height: "16px",
				color: "rgb(55, 65, 81)",
			}),
			isGated: false,
		},
		{
			key: "agenda",
			title: "Agenda",
			path: "/agenda",
			icon: pageToIcon("agenda", {
				width: "16px",
				height: "16px",
				color: "rgb(55, 65, 81)",
			}),
			isGated: false,
		},
		...(role <= RolesEnum.ADMIN
			? [
					{
						key: "organization",
						title: "Mein Labor",
						path: "/organisation",
						icon: pageToIcon("organization", {
							width: "16px",
							height: "16px",
							color: "rgb(55, 65, 81)",
						}),
						isGated: false,
					},
				]
			: []),
		...(role <= RolesEnum.ADMIN
			? [
					{
						key: "auftragsformulare",
						title: "Auftragsformulare",
						path: "/auftragsformulare",
						icon: pageToIcon("auftragsformulare", {
							width: "16px",
							height: "16px",
							color: "rgb(55, 65, 81)",
						}),
						isGated: false,
					},
				]
			: []),
		...(role <= RolesEnum.ADMIN
			? [
					{
						key: "debitoren",
						title: "Debitoren",
						path: "/debitoren",
						icon: pageToIcon("debitoren", {
							width: "16px",
							height: "16px",
							color: "rgb(55, 65, 81)",
						}),
						isGated: true,
					},
					{
						key: "statistics",
						title: "Statistik",
						path: "/statistics",
						icon: pageToIcon("statistics", {
							width: "16px",
							height: "16px",
							color: "rgb(55, 65, 81)",
						}),
						isGated: true,
					},
				]
			: []),
		...(role <= RolesEnum.ADMIN
			? [
					{
						key: "monthly-invoices",
						title: "Sammelrechnungen",
						path: "/monthly-invoices",
						icon: pageToIcon("monthly-invoices", {
							width: "16px",
							height: "16px",
							color: "rgb(55, 65, 81)",
						}),
						isGated: true,
					},
				]
			: []),
		{
			key: "lieferungen",
			title: "Lieferungen",
			path: "/lieferungen",
			icon: pageToIcon("lieferungen", {
				width: "16px",
				height: "16px",
				color: "rgb(55, 65, 81)",
			}),
			isGated: false,
		},
		{
			key: "archive",
			title: "Archiv",
			path: "/archive",
			icon: pageToIcon("archive", {
				width: "16px",
				height: "16px",
				color: "rgb(55, 65, 81)",
			}),
			isGated: true,
		},
		{
			key: "recycle-bin",
			title: "Papierkorb",
			path: "/recycle-bin",
			icon: pageToIcon("recycle-bin", {
				width: "16px",
				height: "16px",
				color: "rgb(55, 65, 81)",
			}),
			isGated: true,
		},
	];
}
